import React, { Component } from 'react';
import { axisBottom, axisLeft } from 'd3-axis';

import PropTypes from 'prop-types';
import cx from 'classnames';
import { select } from 'd3-selection';
import styles from './axis.module.scss';
import { tickFormats } from '../../constants/chart-options';

class Axis extends Component{

    componentDidMount(){
        this.renderAxis();
    }

    renderAxis = () => {
        const { ticks, tickFormat, tickValues, type, scales: { xScale, yScale } } = this.props;

        const d3Axis = {
            x: () => {
                return axisBottom()
                    .scale( xScale() );
            },
            y: () => {
                return axisLeft()
                    .scale( yScale() );
            },
        };

        const axis = d3Axis[type]()
            .ticks( ticks )
            .tickSize( 0, 0 )
            .tickFormat( tickFormat );

        if( tickValues && tickValues.length ){
            // overrides .ticks() with array of explicit values
            axis.tickValues( tickValues );
        }

        select( this.axisElement ).call( axis );
    }

    render(){
        const { height, type, width } = this.props;

        const axisClasses = cx( styles.axis, styles[`${type}-axis`] );
        const axisTransform = {
            x: () => `translate(0, ${height})`,
            y: () => `translate(${width}, 0)`,
        };

        return (
            <g
                className={ axisClasses }
                ref={ el => this.axisElement = el }
                transform={ axisTransform[type]() }
            />
        );
    }
}

Axis.defaultProps = {
    tickFormat: tickFormats.STANDARD_PRECISION,
    ticks: 0,
};

Axis.propTypes = {
    height: PropTypes.number.isRequired,
    margin: PropTypes.shape( {
        bottom: PropTypes.number,
        left: PropTypes.number,
        right: PropTypes.number,
        top: PropTypes.number,
    } ).isRequired,
    scales: PropTypes.object.isRequired,
    tickFormat: PropTypes.func,
    ticks: PropTypes.number,
    tickValues: PropTypes.array,
    type: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
};

export default Axis;
